import React, { useEffect, useState } from 'react';
import '../styles/StatsSection.css';

const StatsSection = () => {
  const stats = [
    { id: 1, icon: 'car', value: 1200, label: 'Successful Drives' },
    { id: 2, icon: 'thumb', value: 1000, label: 'Happy Customers' },
    { id: 3, icon: 'driver', value: 350, label: 'Talented Drivers' },
    { id: 4, icon: 'route', value: 148, label: 'Cities Covered' }
  ];

  const [displayValues, setDisplayValues] = useState(stats.map(() => 0));

  useEffect(() => {
    const durationMs = 1400;
    const frameMs = 16;
    const steps = Math.ceil(durationMs / frameMs);
    let currentStep = 0;

    const timer = setInterval(() => {
      currentStep += 1;
      const progress = Math.min(currentStep / steps, 1);

      setDisplayValues(stats.map((item) => Math.round(item.value * progress)));

      if (progress >= 1) {
        clearInterval(timer);
      }
    }, frameMs);

    return () => clearInterval(timer);
  }, []);

  const renderIcon = (icon) => {
    if (icon === 'car') {
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path fill="currentColor" d="M5.5 11 7 7.5A2.5 2.5 0 0 1 9.3 6h5.4A2.5 2.5 0 0 1 17 7.5l1.5 3.5H20a1 1 0 1 1 0 2h-1v2.2a1.8 1.8 0 0 1-1.8 1.8H17a1 1 0 0 1-1-1v-1H8v1a1 1 0 0 1-1 1h-.2A1.8 1.8 0 0 1 5 15.2V13H4a1 1 0 1 1 0-2h1.5Zm2.4-3-.9 2h10l-.9-2a.5.5 0 0 0-.46-.3H8.36a.5.5 0 0 0-.46.3ZM7.5 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm9 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" />
          <path fill="currentColor" d="m18.2 8.4 1.15 1.15-5.28 5.28-2.6-2.6 1.15-1.15 1.45 1.45 4.13-4.13Z" />
        </svg>
      );
    }

    if (icon === 'thumb') {
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path fill="currentColor" d="M10.2 21H6.4A2.4 2.4 0 0 1 4 18.6v-6.2A2.4 2.4 0 0 1 6.4 10h3.8V21Zm2-11 2.6-5.2A2.3 2.3 0 0 1 16.9 3c1.1 0 2 .9 2 2v3h1.4A2.7 2.7 0 0 1 23 10.7l-1 6.6A2.7 2.7 0 0 1 19.3 20H12.2v-10Z" />
        </svg>
      );
    }

    if (icon === 'driver') {
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path fill="currentColor" d="M4 13.8V11l1.2-2.8A2.6 2.6 0 0 1 7.6 6h5.8A2.6 2.6 0 0 1 15.8 8.2L17 11v2.8h-1v1.6A1.6 1.6 0 0 1 14.4 17h-.8a.6.6 0 0 1-.6-.6V16H8v.4a.6.6 0 0 1-.6.6h-.8A1.6 1.6 0 0 1 5 15.4v-1.6H4Zm2.4-3.6h8.2l-.8-1.8a.7.7 0 0 0-.64-.4H7.04a.7.7 0 0 0-.64.4l-.8 1.8ZM7.5 13.2a.9.9 0 1 0 0-1.8.9.9 0 0 0 0 1.8Zm5.9 0a.9.9 0 1 0 0-1.8.9.9 0 0 0 0 1.8Z" />
          <path fill="currentColor" d="M19 12a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm0 1.2c-2 0-3.6 1.2-3.6 2.8V18h7.2v-2c0-1.6-1.6-2.8-3.6-2.8Z" />
        </svg>
      );
    }

    return (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path fill="currentColor" d="M3 18.8a1 1 0 0 1 1-1h16a1 1 0 0 1 .77 1.64l-.68.8a1 1 0 0 1-.77.36H4.68a1 1 0 0 1-.77-.36l-.68-.8A1 1 0 0 1 3 18.8ZM7.2 8.2a3.2 3.2 0 1 1 6.4 0c0 2.1-3.2 5.9-3.2 5.9S7.2 10.3 7.2 8.2Zm9.8 1.2a2.2 2.2 0 1 1 4.4 0c0 1.5-2.2 4.2-2.2 4.2S17 10.9 17 9.4Z" />
          <path fill="currentColor" d="M10.4 9.4a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4Zm8.8.8a.8.8 0 1 0 0-1.6.8.8 0 0 0 0 1.6Z" />
        </svg>
    );
  };

  return (
    <section className="stats-section" aria-label="Taxi business statistics">
      <div className="stats-container">
        <div className="stats-grid">
          {stats.map((item) => (
            <article key={item.id} className="stat-card">
              <div className="stat-icon">{renderIcon(item.icon)}</div>
              <p className="stat-value">{displayValues[item.id - 1]}</p>
              <p className="stat-label">{item.label}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;